import { render, staticRenderFns } from "./YellowButton.vue?vue&type=template&id=27c6a4ae&scoped=true&"
import script from "./YellowButton.vue?vue&type=script&lang=js&"
export * from "./YellowButton.vue?vue&type=script&lang=js&"
import style0 from "./YellowButton.vue?vue&type=style&index=0&id=27c6a4ae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c6a4ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
